<template>
  <ZDialog v-model:open="isDialogOpen">
    <ZDialogContent class="lg:max-w-[625px] lg:overflow-y-hidden max-w-screen-lg overflow-y-scroll h-full lg:h-auto">
      <ZDialogHeader>
        <ZDialogTitle>{{ $t('contracts.label.create_message') }}</ZDialogTitle>
        <ZDialogDescription>
          {{ $t('contracts.message.create_message') }}
        </ZDialogDescription>
      </ZDialogHeader>
      <template v-if="state == 'loading'">
        <IconAlert type="loading">
          {{ $t('common.action.loading') }}
        </IconAlert>
      </template>
      <template v-else-if="state == 'loaded'">
        <FormValidator ref="form">
          <Field symbol="body" class="pt-4">
            <ZLabel for="body">
              {{ $t('contracts.label.message_body') }}
            </ZLabel>
            <textarea
              id="body"
              v-model="contractMessage.body"
              rows="4"
              class="flex w-full resize-none rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            />
          </Field>
          <Field symbol="needs_answer" class="pt-4">
            <div class="flex gap-2 items-center">
              <Checkbox
                id="needs_answer"
                :checked="contractMessage.needs_answer"
                @update:checked="contractMessage.needs_answer = !contractMessage.needs_answer"
                class="h-6 w-6"
              />
              <ZLabel for="needs_answer">
                {{ $t('contracts.label.message_needs_answer') }}
              </ZLabel>
            </div>
          </Field>
        </FormValidator>
        <ZDialogFooter>
          <Action :disabled="false" @proceed="store">{{ $t('contracts.command.create_message') }} </Action>
        </ZDialogFooter>
      </template>
      <template v-else-if="state == 'error'">
        <IconAlert type="error">
          {{ $t('common.errors.unexpected') }}
        </IconAlert>
      </template>
    </ZDialogContent>
  </ZDialog>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue';
import Action from '@ui/Action.vue';
import {
  ZDialog,
  ZDialogContent,
  ZDialogDescription,
  ZDialogFooter,
  ZDialogHeader,
  ZDialogTitle,
} from '@shadcn/components/ui/dialog';
import FormValidator from '@ui/FormValidator.vue';
import IconAlert from '@ui/IconAlert.vue';
import { ComponentLoadState } from '@/types/ComponentLoadState';
import SelectField from "@ui/SelectField.vue";
import Field from "@ui/FormField.vue";
import {ZLabel} from "@shadcn/components/ui/label";
import ContractMessageDataStoreRequest = App.Data.ContractMessageDataStoreRequest;
import {Checkbox} from "@shadcn/components/ui/checkbox";
import {createOperatorContractMessage} from "@/api/contract";
import FileAttach from "@ui/File/FileAttach.vue";

export default defineComponent({
  components: {
    FileAttach,
    Checkbox,
    ZLabel, Field, SelectField,
    IconAlert,
    FormValidator,
    Action,
    ZDialog,
    ZDialogContent,
    ZDialogDescription,
    ZDialogFooter,
    ZDialogHeader,
    ZDialogTitle,
  },

  emits: ['saved'],

  props: {
    contractId: {
      type: String,
      required: true,
    },
  },

  setup() {
    return {
      toast: inject('toast') as (props: any) => void,
    };
  },

  data() {
    return {
      isDialogOpen: true,
      state: 'loaded' as ComponentLoadState,
      contractMessage: {
        body: '',
        needs_answer: true
      } as ContractMessageDataStoreRequest,
    };
  },

  watch: {
    isDialogOpen() {
      if (!this.isDialogOpen) this.$router.back();
    },
  },

  mounted() {
  },

  methods: {
    store(action: any) {
      createOperatorContractMessage(this.contractId, this.contractMessage)
        .withForm(this.$refs.form as typeof FormValidator)
        .withLoader(action.loader)
        .execute()
        .then(response => {
          this.$router.push({ name: this.ROUTE.MANAGED_CONTRACT_DETAILS, params: { contractId: this.contractId } });

          this.toast({
            title: this.$t('toasts.type.success'),
            description: this.$t('contracts.message.asset_created'),
          });
          this.$emit('saved');
        });
    },
  },
});
</script>
